import PropTypes from 'prop-types';
import { useRef } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, Button, AppBar, Toolbar, Container, Link } from '@mui/material';
// hooks
import useOffSetTop from '../../hooks/minimal/useOffSetTop';
import useResponsive from '../../hooks/minimal/useResponsive';
// utils
import { bgBlur } from '../../utils/minimal/cssStyles';
// config
import { HEADER } from '../../config-global';
// routes
import { PATH_DASHBOARD, PATH_DOCS } from '../../routes/paths';
// components
import Logo from '../../components/minimal/logo';
import Label from '../../components/minimal/label';
//
import navConfig from './nav/config-navigation';
import NavMobile from './nav/mobile';
import NavDesktop from './nav/desktop';
import { useLocales } from "../../locales";
import { Link as RouterLink } from "react-router-dom";
import { getMarketplaceLogo, isNimi, getMarketPlaceName } from "../../utils/market";
import { varFade, MotionContainer } from '../../components/minimal/animate';
import { m } from 'framer-motion';
import Iconify from '../../components/minimal/iconify';
import { useSettingsContext } from '../../components/minimal/settings';
import { getBootstrapData } from '../../utils/market';
// ----------------------------------------------------------------------

export default function Header() {
  const carouselRef = useRef(null);
  const { translate } = useLocales();
  const theme = useTheme();

  const isDesktop = useResponsive('up', 'md');
  const { themeDirection } = useSettingsContext();
  const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP);
  const isOffsetScreenHeight = useOffSetTop(600);
  const currentMarketplaceLogo = getMarketplaceLogo();
  const logoClick = () => window.location.href = "/";
  const logoComponent = currentMarketplaceLogo ? <img onClick={logoClick} src={currentMarketplaceLogo.path} style={{ width: currentMarketplaceLogo.width, height: currentMarketplaceLogo.height }} alt="" /> : <Logo onClick={logoClick} />
  const landingPageCta = getBootstrapData().landingPageCta || "#book-a-demo"

  return (
    <AppBar ref={carouselRef} color="transparent" sx={{ boxShadow: 0 }}>
      <Toolbar
        disableGutters
        sx={{
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_MAIN_DESKTOP,
          },
          transition: theme.transitions.create(['height', 'background-color'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
          ...(isOffset && {
            ...bgBlur({ color: theme.palette.background.default }),
            height: {
              md: HEADER.H_MAIN_DESKTOP - 16,
            },
          }),
        }}
      >
        <Container sx={{ height: 1, display: 'flex', alignItems: 'center' }}>
          {logoComponent}

          {/*<Link*/}
          {/*  href={PATH_DOCS.changelog}*/}
          {/*  target="_blank"*/}
          {/*  rel="noopener"*/}
          {/*  underline="none"*/}
          {/*  sx={{ ml: 1 }}*/}
          {/*>*/}
          {/*  <Label color="info"> v4.1.0 </Label>*/}
          {/*</Link>*/}

          <Box sx={{ flexGrow: 1 }} />

          {/* {isDesktop && <NavDesktop isOffset={isOffset} data={navConfig} />} */}
          {isNimi() && isOffsetScreenHeight && <MotionContainer>
            <m.div variants={varFade().in}>
              <Button
                href={landingPageCta}
                color="inherit"
                size={isDesktop ? "large" : "medium"}
                variant="contained"
                endIcon={themeDirection === 'rtl' ? <Iconify icon="eva:flash-fill" width={24} /> : null}
                startIcon={themeDirection === 'rtl' ? null : <Iconify icon="eva:flash-fill" width={24} />}
                sx={{
                  bgcolor: 'text.primary',
                  color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
                  '&:hover': {
                    bgcolor: 'text.primary',
                  },
                }}
              >
                {translate('home.main_cta')}
                {/*Live Preview*/}
              </Button>
            </m.div>
          </MotionContainer>}

          {/* {!isDesktop && <NavMobile isOffset={isOffset} data={navConfig} />} */}
        </Container>
      </Toolbar>

      {isOffset && <Shadow />}
    </AppBar>
  );
}

// ----------------------------------------------------------------------

Shadow.propTypes = {
  sx: PropTypes.object,
};

function Shadow({ sx, ...other }) {
  return (
    <Box
      sx={{
        left: 0,
        right: 0,
        bottom: 0,
        height: 24,
        zIndex: -1,
        m: 'auto',
        borderRadius: '50%',
        position: 'absolute',
        width: `calc(100% - 48px)`,
        boxShadow: (theme) => theme.customShadows.z8,
        ...sx,
      }}
      {...other}
    />
  );
}
